import { BuildType } from '../../enums/build/build-type';

import type { Buttons } from './button';
import { getButtons, getRedesignButtons } from './button';
import type { Colors } from './colors';
import { getColors } from './colors';
import type { CommonStyle } from './common';
import { getCommon } from './common';
import type { Fonts } from './fonts';
import { getFonts } from './fonts';
import type { Forms } from './forms';
import { getForms, getRedesignedForms } from './forms';
import type { Logos } from './logos';
import { getLogos } from './logos';
import type { TextStyles } from './text-styles';
import { getTextStyles } from './text-styles';

export type Styling = {
  colors: Colors;
  common: CommonStyle;
  logos: Logos;
  buttons: Buttons;
  redesignButtons: Partial<Buttons>;
  forms: Forms;
  redesignForms: Partial<Forms>;
  fonts: Fonts;
  texts: TextStyles;
};

const getBuildTypeButtons = (buildType: BuildType, colors: Colors, fonts: Fonts) => {
  switch (buildType) {
    case BuildType.HARBOUR:
    case BuildType.MERIDIAN:
      return getButtons(buildType, colors, fonts);
    default:
      return getRedesignButtons(colors, fonts);
  }
};

export const getStyling = (buildType: BuildType) => {
  const colors = getColors(buildType);
  const fonts = getFonts(buildType);
  const common = getCommon(buildType, colors, fonts);
  const logos = getLogos(buildType);
  const buttons = getBuildTypeButtons(buildType, colors, fonts);
  const redesignButtons = getRedesignButtons(colors, fonts);
  const forms = getForms(buildType, colors, fonts);
  const redesignForms = getRedesignedForms(colors);
  const texts = getTextStyles(buildType);

  return {
    colors,
    common,
    logos,
    buttons,
    forms,
    redesignForms,
    fonts,
    texts,
    redesignButtons,
  } as Styling;
};

export const defaultStyling = getStyling(BuildType.DAVID_LLOYD_UK);
